var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"centered loading-icon",attrs:{"src":require("../../public/img/johannes-huther-icon.svg"),"alt":"Icon of Johannes Huther"}})}
var staticRenderFns = []

export { render, staticRenderFns }